import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    applicantId: Number,
    reason: String 
  }

  connect() {
    console.log("Deletion date recalculation controller connected")
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    // Polling alle 2 Sekunden, um den Status zu prüfen
    this.pollingInterval = setInterval(() => {
      this.checkRecalculationStatus()
    }, 2000)
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
      this.pollingInterval = null
    }
  }

  async checkRecalculationStatus() {
    try {
      const response = await fetch(`/backend/applicants/${this.applicantIdValue}/deletion_date_status`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const data = await response.json()
        
        if (data.status === 'completed') {
          this.showCompleted(data)
          this.stopPolling()
        } else if (data.status === 'error') {
          this.showError(data.message)
          this.stopPolling()
        }
        // Wenn status === 'processing', dann weiter warten
      }
    } catch (error) {
      console.error('Error checking recalculation status:', error)
      this.showError('Fehler beim Prüfen des Status')
      this.stopPolling()
    }
  }

  showCompleted(data) {
    const spinner = this.element.querySelector('[data-deletion-date-recalculation-target="spinner"]')
    const checkmark = this.element.querySelector('[data-deletion-date-recalculation-target="checkmark"]')
    const message = this.element.querySelector('[data-deletion-date-recalculation-target="message"]')
    const reason = this.element.querySelector('[data-deletion-date-recalculation-target="reason"]')

    if (spinner) spinner.classList.add('hidden')
    if (checkmark) checkmark.classList.remove('hidden')
    if (message) message.textContent = 'Löschdatum erfolgreich neu berechnet'
    if (reason) reason.textContent = data.reason || 'Policy-Änderung verarbeitet'

    // Nach 3 Sekunden automatisch ausblenden
    setTimeout(() => {
      this.dismiss()
    }, 3000)
  }

  showError(errorMessage) {
    const spinner = this.element.querySelector('[data-deletion-date-recalculation-target="spinner"]')
    const checkmark = this.element.querySelector('[data-deletion-date-recalculation-target="checkmark"]')
    const message = this.element.querySelector('[data-deletion-date-recalculation-target="message"]')
    const reason = this.element.querySelector('[data-deletion-date-recalculation-target="reason"]')

    if (spinner) spinner.classList.add('hidden')
    if (checkmark) {
      checkmark.classList.remove('hidden')
      checkmark.classList.add('text-red-600')
    }
    if (message) {
      message.textContent = 'Fehler bei der Neuberechnung'
      message.classList.add('text-red-800')
    }
    if (reason) {
      reason.textContent = errorMessage
      reason.classList.add('text-red-600')
    }
  }

  dismiss() {
    this.element.remove()
  }
}






